import { useRef, useEffect} from "react";

export * from "./authentication";

// number of notifications the backend sends at a time
export const pageSize = 10;

export const fetchError = error => ({
  type: "ALERT",
  payload: {
    type: "ERROR",
    status: error.response ? error.response.status : null,
    headers: error.response ? error.response.headers : null,
    data: error.response ? error.response.data : null,
    message: error.message,
  },
});

export const buildAlert = (type, title, message, messageList) => ({
  type: "ALERT",
  payload: {
    type,
    title,
    message,
    messageList,
    titleKey: null,
    titleDefault: null,
    messageKey: null,
    messageDefault: null,
    messageParams: null,
    localizedMessages: null,
  },
});

export const buildAlertWithLocalizedMessage = (type, titleKey, titleDefault, messageKey, messageDefault, messageParams) => ({
  type: "ALERT",
  payload: {
    type,
    title: null,
    message: null,
    messageList: null,
    titleKey,
    titleDefault,
    messageKey,
    messageDefault,
    messageParams,
    localizedMessages: null,
  },
});

export const buildAlertWithLocalizedMessages = (type, titleKey, titleDefault, localizedMessages) => ({
  type: "ALERT",
  payload: {
    type,
    title: null,
    message: null,
    messageList: null,
    titleKey,
    titleDefault,
    messageKey: null,
    messageDefault: null,
    messageParams: null,
    localizedMessages,
  },
});

export function useTimeout(callback, delay) {
  const timeoutRef = useRef();
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (typeof delay === "number") {
      timeoutRef.current = setTimeout(() => callbackRef.current(), delay);
      return () => clearTimeout(timeoutRef.current);
    }
  }, [delay]);

  return timeoutRef;
}

export const toggleLoadingGlobal = showLoadingGlobal => dispatch =>
  showLoadingGlobal === true
    ? dispatch({ type: "LOADING_GLOBAL_SHOW" })
    : dispatch({ type: "LOADING_GLOBAL_HIDE" });
